// extracted by mini-css-extract-plugin
export var control = "index-module--control--6e252 flex mOnly_flex-wrap items-center gap-2 transition-all duration-300";
export var controlSubmitted = "index-module--controlSubmitted--9b0d0 opacity-50 pointer-events-none";
export var input = "index-module--input--ceaf3 flex-1 focus_outline-none py-2 border-b border-black bg-transparent text-base placeholder_text-black placeholder_opacity-50";
export var root = "index-module--root--029f9 mt-4";
export var submit = "index-module--submit--e2760";
export var wrapper = "index-module--wrapper--1be73";